// Bundle Builder — "Build your bundle" category modal for the Base/Moto PDP bundle block.
// Flow: selecting the "Build your bundle" option (a radio in Bundle & Save) relabels the main
// Add-to-cart button; clicking that button opens this modal. Products are grouped into category
// tiles (from pp_bundle.builder_categories) that expand one at a time so the customer isn't
// overwhelmed. Toggle-only (qty 1); live total with the add-ons-only discount (mirrors BXGY).
// "Add bundle to cart" uses the same cart/add.js flow as the FAR Builder.

function bbxFormatMoney(cents, format) {
  if (typeof cents === 'string') cents = cents.replace('.', '');
  var fmt = format || '${{amount}}';
  function delim(number, precision, thousands, decimal) {
    precision = precision == null ? 2 : precision;
    thousands = thousands == null ? ',' : thousands;
    decimal = decimal == null ? '.' : decimal;
    if (isNaN(number) || number == null) return '0';
    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var c = parts[1] ? decimal + parts[1] : '';
    return dollars + c;
  }
  var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
  var key = m ? m[1] : 'amount';
  var value;
  switch (key) {
    case 'amount_no_decimals': value = delim(cents, 0); break;
    case 'amount_with_comma_separator': value = delim(cents, 2, '.', ','); break;
    case 'amount_no_decimals_with_comma_separator': value = delim(cents, 0, '.', ','); break;
    case 'amount_with_apostrophe_separator': value = delim(cents, 2, "'", '.'); break;
    case 'amount_with_space_separator': value = delim(cents, 2, ' ', ','); break;
    case 'amount_no_decimals_with_space_separator': value = delim(cents, 0, ' ', ''); break;
    default: value = delim(cents, 2);
  }
  return fmt.replace(/\{\{\s*\w+\s*\}\}/, value);
}

if (!customElements.get('bundle-builder')) {
  customElements.define('bundle-builder', class extends HTMLElement {
    connectedCallback() {
      this.base = parseInt(this.dataset.basePrice, 10) || 0;
      this.discount = parseFloat(this.dataset.discount) || 0;
      this.fmt = this.dataset.moneyFormat || '${{amount}}';
      this.mainVariant = Number(this.dataset.mainVariant);
      this.saveWord = this.dataset.saveWord || 'You save';
      this.atcText = this.dataset.atcText || 'Build your bundle';
      this.loupeLabel = this.dataset.loupeLabel || 'View product';
      this.dimsLabel = this.dataset.dimsLabel || 'Dimensions';
      this.weightLabel = this.dataset.weightLabel || 'Weight';
      this.detAdd = this.dataset.detAdd || 'Add to bundle';
      this.detAdded = this.dataset.detAdded || 'In bundle';
      this.infoLabel = this.dataset.infoLabel || 'Go to the product page';
      this.qtyLessLabel = this.dataset.qtyLess || 'One less';
      this.qtyMoreLabel = this.dataset.qtyMore || 'One more';
      // Minimum add-ons before the bundle may be added. 0 = no minimum.
      this.minAddons = parseInt(this.dataset.minAddons, 10) || 0;
      this.minHintText = this.dataset.minHint || '';
      this.minLeftText = this.dataset.minLeft || '';
      this.modal = this.querySelector('[data-bbx-modal]');
      this.dialog = this.querySelector('.bbx__dialog');
      this.totalEl = this.querySelector('[data-bbx-total]');
      this.compareEl = this.querySelector('[data-bbx-compare]');
      this.saveEl = this.querySelector('[data-bbx-save]');
      this.addBtn = this.querySelector('[data-bbx-add]');
      this.minHintEl = this.querySelector('[data-bbx-minhint]');
      this.inputs = Array.prototype.slice.call(this.querySelectorAll('.bbx__input'));
      this.cats = Array.prototype.slice.call(this.querySelectorAll('.bbx__cat'));
      // Desktop preview column refs.
      this.pv = {
        wrap: this.querySelector('[data-bbx-preview]'),
        empty: this.querySelector('[data-bbx-pv-empty]'),
        inner: this.querySelector('[data-bbx-pv-inner]'),
        img: this.querySelector('[data-bbx-pv-img]'),
        img2: this.querySelector('[data-bbx-pv-img2]'),
        title: this.querySelector('[data-bbx-pv-title]'),
        price: this.querySelector('[data-bbx-pv-price]'),
        was: this.querySelector('[data-bbx-pv-was]'),
        desc: this.querySelector('[data-bbx-pv-desc]'),
        loupe: this.querySelector('[data-bbx-pv-loupe]'),
        dims: this.querySelector('[data-bbx-pv-dims]'),
        dimsLabel: this.querySelector('[data-bbx-pv-dims-label]'),
        dimsValue: this.querySelector('[data-bbx-pv-dims-value]'),
        weight: this.querySelector('[data-bbx-pv-weight]'),
        weightLabelEl: this.querySelector('[data-bbx-pv-weight-label]'),
        weightValue: this.querySelector('[data-bbx-pv-weight-value]'),
      };
      // Product detail overlay (desktop): opened by the loupe on the preview photo.
      this.det = {
        wrap: this.querySelector('[data-pqv]'),
        thumbs: this.querySelector('[data-pqv-thumbs]'),
        prev: this.querySelector('[data-pqv-prev]'),
        next: this.querySelector('[data-pqv-next]'),
        title: this.querySelector('[data-pqv-title]'),
        price: this.querySelector('[data-pqv-price]'),
        was: this.querySelector('[data-pqv-was]'),
        blurb: this.querySelector('[data-pqv-blurb]'),
        specs: this.querySelector('[data-pqv-specs]'),
        specsPanel: this.querySelector('[data-pqv-panel-specs]'),
        pack: this.querySelector('[data-pqv-pack]'),
        packPanel: this.querySelector('[data-pqv-panel-pack]'),
        body: this.querySelector('[data-pqv-body]'),
        rte: this.querySelector('[data-pqv-rte]'),
        oos: this.querySelector('[data-pqv-oos]'),
        add: this.querySelector('[data-pqv-add]'),
        full: this.querySelector('[data-pqv-full]'),
        qty: this.querySelector('[data-pqv-qty]'),
        qtyVal: this.querySelector('[data-pqv-qty-val]'),
        qtyDec: this.querySelector('[data-pqv-qty-dec]'),
        qtyInc: this.querySelector('[data-pqv-qty-inc]'),
      };
      this.wide = window.matchMedia('(min-width: 1120px)');
      // Sheet dismissal comes from the shared gesture layer in product-quick-view.js.
      // Photo switching is native scroll-snap, so there is nothing to wire for it.
      if (this.det.wrap) {
        this.det.wrap.addEventListener('pqv:close', () => this.closeDetail());
      }
      this.head = this.querySelector('.bbx__head');
      // Mobile summary screen refs.
      this.summaryList = this.querySelector('[data-bbx-summary-list]');
      this.summaryEmpty = this.querySelector('[data-bbx-summary-empty]');
      this.summaryBar = this.querySelector('[data-bbx-summary-open]');
      this.sumBarCount = this.querySelector('[data-bbx-bar-count]');
      this.selCount = this.querySelector('[data-bbx-sel-count]');
      // Desktop running selection (in the preview column).
      this.deskSel = this.querySelector('[data-bbx-desk-sel]');
      this.deskSelList = this.querySelector('[data-bbx-desk-sel-list]');
      this.deskCount = this.querySelector('[data-bbx-desk-count]');
      this.busy = false;
      this.armed = false;

      // Modal-scoped listeners are delegated on the MODAL (not `this`), because open() reparents the
      // modal into <body> — listeners on `this` would then stop receiving its inner events.
      // Selection drives the total AND the desktop preview: checking a product opens the preview on
      // that product; unchecking the last one closes it again (and restores the left-column blurbs).
      this.modal.addEventListener('change', (e) => {
        // POJISTKA PROTI DVOJÍMU ZPRACOVÁNÍ. Tyhle posluchače jsou navěšené INLINE arrow
        // funkcí, takže je addEventListener nedokáže deduplikovat — každý průchod
        // connectedCallback přidá další. A modal se v open() přesouvá do <body>, takže
        // host se může znovu připojit (morf sekce, view transition, editor motivu) a
        // posluchače se na TÉŽE instanci modalu navrství. Jeden tap se pak zpracoval
        // dvakrát: setQty přičetlo 2, takže počítadlo v „Build your bundle" ukazovalo
        // jen lichá čísla. Značka se píše na SAMOTNOU UDÁLOST, takže druhé doručení
        // téže události odpadne, ale dva skutečné tapy projdou.
        if (e.__bbxChangeHandled) return;
        e.__bbxChangeHandled = true;
        if (!(e.target && e.target.classList && e.target.classList.contains('bbx__input'))) return;
        this.update();
        this.syncSummary();
        var checked = this.selected();
        if (checked.length === 0) { this.closePreview(); return; }
        var item = e.target.closest('[data-bbx-item]');
        if (e.target.checked && item) { this.showPreview(item); return; }
        var lastItem = checked[checked.length - 1].closest('[data-bbx-item]');
        if (lastItem) this.showPreview(lastItem);
      });
      // One category open at a time (native <details> toggle event).
      this.cats.forEach((d) => {
        d.addEventListener('toggle', () => {
          if (d.open) this.cats.forEach((o) => { if (o !== d) o.open = false; });
        });
      });
      // Summary screen controls (mobile): open / back / remove. The loupe is a plain <a> that navigates.
      this.modal.addEventListener('click', (e) => {
        // Táž pojistka jako u 'change' výše — viz komentář tam.
        if (e.__bbxClickHandled) return;
        e.__bbxClickHandled = true;
        if (!e.target.closest) return;
        if (e.target.closest('[data-bbx-summary-open]')) { if (this.dialog) this.dialog.classList.add('is-summary'); this.renderSummary(); return; }
        if (e.target.closest('[data-bbx-summary-back]')) { if (this.dialog) this.dialog.classList.remove('is-summary'); return; }
        var rm = e.target.closest('[data-bbx-sum-remove]');
        if (rm) {
          var inp = this.inputs.filter((i) => i.value === rm.getAttribute('data-bbx-sum-remove'))[0];
          if (inp) { inp.checked = false; this.update(); this.syncSummary(); if (!this.selected().length) this.closePreview(); }
          return;
        }
        // Počty v seznamu „Your selection" (obě podoby, mobilní souhrn i pravý sloupec).
        var qb = e.target.closest('[data-bbx-sum-qty]');
        if (qb) {
          var qInp = this.inputs.filter((i) => i.value === qb.getAttribute('data-bbx-sum-qty'))[0];
          if (qInp) {
            var step = qb.getAttribute('data-bbx-step') === 'up' ? 1 : -1;
            this.setQty(qInp, this.qtyOf(qInp) + step);
          }
          return;
        }
        // Every loupe opens the quick view, at both breakpoints. The right-hand preview column
        // is reached by clicking the row itself, which also selects it - the loupe is the
        // "look without picking" path.
        var pk = e.target.closest('[data-bbx-sum-peek]');
        if (pk) {
          var pkInp = this.inputs.filter((i) => i.value === pk.getAttribute('data-bbx-sum-peek'))[0];
          var pkRow = pkInp ? pkInp.closest('[data-bbx-item]') : null;
          if (pkRow) { e.preventDefault(); this.openDetail(pkRow, pk); return; }
        }
        if (e.target.closest('[data-pqv-prev]')) { this.showImage((this.galleryIndex || 0) - 1); return; }
        if (e.target.closest('[data-pqv-next]')) { this.showImage((this.galleryIndex || 0) + 1); return; }
        if (e.target.closest('[data-pqv-close]')) { this.closeDetail(); return; }
        if (e.target.closest('[data-pqv-qty-dec]')) { this.stepDetailQty(-1); return; }
        if (e.target.closest('[data-pqv-qty-inc]')) { this.stepDetailQty(1); return; }
        if (e.target.closest('[data-pqv-add]')) { this.toggleDetailItem(); return; }
        // Both loupes stay real <a href> elements so a no-JS visitor still reaches the PDP.
        // With JS we intercept them and open the in-place detail overlay instead.
        var lp = e.target.closest('[data-bbx-pv-loupe]');
        if (lp && this.wide.matches && this.previewItem) { e.preventDefault(); this.openDetail(this.previewItem, lp); return; }
        // KLIK NA ŘÁDEK PRODUKTU OTEVŘE DETAIL, nezaškrtne ho. Řádek je <label> s checkboxem
        // uvnitř, takže by ho prohlížeč zaškrtl sám - proto `preventDefault()`. Zaškrtne se
        // teprve tlačítkem v detailu.
        //
        // Proč: zpětná vazba od více lidí byla, že okamžité vhození do sestavy je na zákazníka
        // moc. Detail je mezikrok, ve kterém si produkt prohlédne, zvolí počet a teprve pak
        // potvrdí. Lupa na řádku tím ztratila smysl a je z markupu odstraněná - klik na řádek
        // dělá totéž.
        var row = e.target.closest('[data-bbx-item]');
        if (row) {
          // Klik na ovládací prvek uvnitř řádku (kdyby tam někdy byl) si řeší on sám.
          if (e.target.closest('a, button')) return;
          e.preventDefault();
          this.openDetail(row, null);
          return;
        }
      });
      if (this.addBtn) this.addBtn.addEventListener('click', () => { if (this.minMet()) this.addToCart(); });

      // Close controls (backdrop / close button / Esc). Use this.modal.contains (not this.contains)
      // because the modal is reparented into <body> on open.
      this.onDocClick = (e) => {
        if (this.modal && !this.modal.hidden && e.target.closest && e.target.closest('[data-bbx-close]') && this.modal.contains(e.target)) this.close();
      };
      document.addEventListener('click', this.onDocClick);
      this.onKey = (e) => {
        if (e.key !== 'Escape') return;
        if (this.det && this.det.wrap && !this.det.wrap.hidden) { this.closeDetail(); return; }
        if (this.modal && !this.modal.hidden) this.close();
      };
      document.addEventListener('keydown', this.onKey);

      // ── ATC coupling ──────────────────────────────────────────────
      // The "Build your bundle" option is a radio in the Bundle & Save group. When it's selected,
      // relabel the page's main Add-to-cart button(s) and intercept their click to open the modal
      // instead of adding just the bag.
      this.buildRadio = document.querySelector('[data-bbx-build]');
      if (this.buildRadio && this.buildRadio.name) {
        var self = this;
        document.querySelectorAll('input[name="' + this.buildRadio.name.replace(/"/g, '\\"') + '"]').forEach(function (r) {
          r.addEventListener('change', function () { self.syncArmed(); });
        });
        this.syncArmed();
      }
      this.onAtcCapture = (e) => {
        if (!this.armed) return;
        var btn = e.target.closest && e.target.closest('button, [role="button"], a.button');
        if (!btn || this.contains(btn)) return;
        if (!btn.querySelector('.add-to-cart-text')) return; // only the main Add-to-cart
        e.preventDefault();
        e.stopImmediatePropagation();
        this.open();
      };
      document.addEventListener('click', this.onAtcCapture, true);

      // Vlastní otvírák. Používá se, když na stránce není „Přidat do košíku", které by se dalo
      // odchytit - typicky když je všechno vyprodané a builder slouží jako konfigurátor.
      this.querySelectorAll('[data-bbx-open]').forEach((btn) => {
        btn.addEventListener('click', (e) => { e.preventDefault(); this.open(); });
      });

      this.update();
      this.syncSummary();
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocClick);
      document.removeEventListener('click', this.onAtcCapture, true);
      document.removeEventListener('keydown', this.onKey);
      document.documentElement.style.removeProperty('overflow');
      // Remove the modal if it was reparented into <body>, so it doesn't outlive the element.
      if (this.modal && this.modal.parentNode === document.body) document.body.removeChild(this.modal);
    }

    // ── Desktop preview column ──
    // The preview column is pulled up over the heading's row; CSS needs the heading's real
    // height to know how far, and it changes when the heading wraps.
    syncHeadHeight() {
      if (!this.head || !this.dialog) return;
      var h = this.head.offsetHeight;
      if (h > 0) this.dialog.style.setProperty('--bbx-head-h', h + 'px');
    }

    showPreview(item) {
      if (!this.pv || !this.pv.wrap || !this.wide.matches) return; // desktop-only mechanic
      this.syncHeadHeight();
      var d = item.dataset;
      this.previewItem = item;
      if (this.pv.img) { this.pv.img.src = d.img || ''; this.pv.img.alt = d.title || ''; }
      if (this.pv.img2) {
        if (d.img2) { this.pv.img2.src = d.img2; this.pv.img2.hidden = false; }
        else { this.pv.img2.hidden = true; this.pv.img2.removeAttribute('src'); }
      }
      if (this.pv.title) this.pv.title.textContent = d.title || '';
      // Price shows the bundle discount: original struck through + discounted price.
      var input = item.querySelector('.bbx__input');
      var cents = input ? (parseInt(input.getAttribute('data-price'), 10) || 0) : 0;
      if (this.discount > 0 && cents > 0) {
        var disc = cents - Math.round((cents * this.discount) / 100);
        if (this.pv.price) this.pv.price.textContent = this.money(disc);
        if (this.pv.was) { this.pv.was.textContent = this.money(cents); this.pv.was.hidden = false; }
      } else {
        if (this.pv.price) this.pv.price.textContent = cents ? this.money(cents) : (d.priceStr || '');
        if (this.pv.was) this.pv.was.hidden = true;
      }
      if (this.pv.desc) this.pv.desc.textContent = d.desc || '';
      // Dimensions row (custom.pp_dimensions). Hidden outright when unset, so
      // products without measurements show no empty label.
      if (this.pv.dims) {
        if (d.dims) {
          if (this.pv.dimsLabel) this.pv.dimsLabel.textContent = this.dimsLabel;
          if (this.pv.dimsValue) this.pv.dimsValue.textContent = d.dims;
          this.pv.dims.hidden = false;
        } else {
          this.pv.dims.hidden = true;
        }
      }
      if (this.pv.weight) {
        if (d.weight) {
          if (this.pv.weightLabelEl) this.pv.weightLabelEl.textContent = this.weightLabel;
          if (this.pv.weightValue) this.pv.weightValue.textContent = d.weight;
          this.pv.weight.hidden = false;
        } else {
          this.pv.weight.hidden = true;
        }
      }
      // Hover loupe on the photo → the product page (replaces the old "View details" link).
      if (this.pv.loupe) {
        if (d.url) { this.pv.loupe.href = d.url; this.pv.loupe.hidden = false; }
        else { this.pv.loupe.hidden = true; }
      }
      if (this.pv.empty) this.pv.empty.hidden = true;
      if (this.pv.inner) this.pv.inner.hidden = false;
      if (this.dialog) this.dialog.classList.add('is-previewing'); // zapíná preview kolonu i širší dialog
    }
    // ── Product detail overlay (desktop) ──
    // Paints instantly from the clicked item's data-* attributes, then enriches with the real
    // gallery and body copy from /products/<handle>.js. That endpoint is locale-aware via the
    // item's own URL, so /cs returns the translated description.
    openDetail(item, opener) {
      if (!this.det || !this.det.wrap || !item) return;
      var d = item.dataset;
      this.detailItem = item;
      // On mobile the opener is the row loupe; the preview loupe does not exist there, so
      // returning focus to it would drop focus on a display:none element.
      this.detailOpener = opener || (this.pv && this.pv.loupe) || null;

      if (this.det.title) this.det.title.textContent = d.title || '';
      if (this.det.blurb) this.det.blurb.textContent = d.desc || '';
      if (this.det.full) this.det.full.href = d.url || '#';

      var input = item.querySelector('.bbx__input');
      var cents = input ? (parseInt(input.getAttribute('data-price'), 10) || 0) : 0;
      if (this.discount > 0 && cents > 0) {
        var disc = cents - Math.round((cents * this.discount) / 100);
        if (this.det.price) this.det.price.textContent = this.money(disc);
        if (this.det.was) { this.det.was.textContent = this.money(cents); this.det.was.hidden = false; }
      } else {
        if (this.det.price) this.det.price.textContent = cents ? this.money(cents) : (d.priceStr || '');
        if (this.det.was) this.det.was.hidden = true;
      }

      // Dimensions / weight reuse the labels already handed to the preview column.
      var specRows = 0;
      if (this.det.specs) {
        this.det.specs.textContent = '';
        var rows = [[this.dimsLabel, d.dims], [this.weightLabel, d.weight]];
        rows.forEach((r) => {
          if (!r[1]) return;
          specRows++;
          var dt = document.createElement('dt'); dt.textContent = r[0];
          var dd = document.createElement('dd'); dd.textContent = r[1];
          this.det.specs.appendChild(dt); this.det.specs.appendChild(dd);
        });
      }
      if (this.det.specsPanel) this.det.specsPanel.hidden = specRows === 0;

      // Pack contents come from the row's data-pack, so opening the panel costs no request.
      // Ordinary add-ons have none, and the panel stays hidden rather than showing an empty list.
      if (this.det.pack) {
        this.det.pack.textContent = '';
        var packItems = (d.pack || '').split('|').map((x) => x.trim()).filter(Boolean);
        packItems.forEach((t) => {
          var li = document.createElement('li');
          li.textContent = t;
          this.det.pack.appendChild(li);
        });
        if (this.det.packPanel) this.det.packPanel.hidden = packItems.length === 0;
      }

      // Start with the images we already have; the fetch replaces them if it succeeds.
      this.setDetailGallery([d.img, d.img2].filter(Boolean), d.title || '');
      if (this.det.body) this.det.body.hidden = true;

      // Hláška o vyprodání patří k produktu, ne k patě modalu - proto se plní až tady, podle
      // toho, jestli je otevřená položka nedostupná.
      if (this.det.oos) {
        var note = this.getAttribute('data-oos-note') || '';
        var soldOut = item.classList.contains('bbx__item--oos');
        this.det.oos.textContent = note;
        this.det.oos.hidden = !(note && soldOut);
      }

      this.det.wrap.hidden = false;
      this.syncDetailButton();
      this.syncDetailQty();
      if (this.det.add) this.det.add.focus();

      this.loadDetail(d.handle, d.url, d.title || '');
    }

    async loadDetail(handle, url, alt) {
      if (!handle && !url) return;
      var token = (this.detailToken = (this.detailToken || 0) + 1);
      var base = url || '/products/' + handle;
      try {
        var res = await fetch(base.split('?')[0] + '.js', { headers: { Accept: 'application/json' } });
        if (!res.ok) return;                       // silent: the overlay already shows the basics
        var p = await res.json();
        if (token !== this.detailToken || !this.detailItem) return;   // a newer open won
        var imgs = (p.images || []).map((u) => (u.indexOf('//') === 0 ? 'https:' + u : u));
        if (imgs.length) this.setDetailGallery(imgs, alt);
        if (this.det.body && this.det.rte && p.description) {
          this.det.rte.innerHTML = p.description;
          this.det.body.hidden = false;
          // Panels stay open in the quick view, so this is reset to open rather than collapsed -
          // otherwise fetching the description would close a panel the shopper expects to be up.
          this.det.body.open = true;
        }
      } catch (err) {
        /* offline or blocked: the data-* content stays, which is the point of painting first */
      }
    }


    /* The carousel is shared with the card overlay - see window.pqvGallery in
       product-quick-view.js. Resolved lazily: both scripts are deferred and their order is
       not guaranteed, but nothing calls this before the customer opens the overlay. */
    gal() {
      if (!this.det || !this.det.wrap || !window.pqvGallery) return null;
      return window.pqvGallery(this.det.wrap);
    }

    setDetailGallery(urls, alt) {
      this.gallery = (urls || []).filter(Boolean);
      this.galleryAlt = alt || '';
      this.galleryIndex = 0;
      var g = this.gal();
      if (g) g.set(this.gallery, this.galleryAlt, 1200);
    }

    showImage(i) {
      var g = this.gal();
      if (!g) return;
      g.go(i);
      this.galleryIndex = g.index();
    }

    toggleDetailItem() {
      if (!this.detailItem) return;
      var input = this.detailItem.querySelector('.bbx__input');
      if (!input || input.disabled) return;
      var adding = !input.checked;
      input.checked = !input.checked;
      // Removing the last item makes the change handler call closePreview(); without this guard it
      // would tear the overlay down under the cursor of the person who just clicked inside it.
      this.togglingFromDetail = true;
      try { input.dispatchEvent(new Event('change', { bubbles: true })); }
      finally { this.togglingFromDetail = false; }
      this.syncDetailButton();
      this.syncDetailQty();
      // Adding finishes the errand: the shopper opened the loupe to decide, decided yes, and wants
      // to be back in the list picking the next thing. Staying open made them hunt for the close
      // button to carry on.
      // Removing deliberately does NOT close - it leaves them looking at the product they just
      // took out, one click from putting it back.
      if (adding) this.closeDetail();
    }

    syncDetailButton() {
      if (!this.det || !this.det.add) return;
      var input = this.detailItem ? this.detailItem.querySelector('.bbx__input') : null;
      var inBundle = !!(input && input.checked);
      this.det.add.textContent = inBundle ? this.detAdded : this.detAdd;
      this.det.add.classList.toggle('is-in', inBundle);
      this.det.add.disabled = !!(input && input.disabled);
      this.det.add.setAttribute('aria-pressed', inBundle ? 'true' : 'false');
    }

    closeDetail() {
      if (!this.det || !this.det.wrap || this.det.wrap.hidden) return;
      this.det.wrap.hidden = true;
      this.det.wrap.classList.remove('pqv--expanded');
      this.detailItem = null;
      var back = this.detailOpener;
      this.detailOpener = null;
      if (back && back.isConnected && back.offsetParent !== null) back.focus();
      else if (this.pv && this.pv.loupe) this.pv.loupe.focus();
    }

    closePreview() {
      this.previewItem = null;
      if (!this.togglingFromDetail) this.closeDetail();
      if (this.pv) {
        if (this.pv.inner) this.pv.inner.hidden = true;
        if (this.pv.empty) this.pv.empty.hidden = false;
      }
      // `is-previewing` řídí šířku dialogu i zobrazení preview kolony (viz CSS v
      // premium-bundle.liquid). Owner chce popup na klik, ne kolonu otevřenou od začátku;
      // poskakování řeší to, že `max-width` není v transition dialogu.
      if (this.dialog) this.dialog.classList.remove('is-previewing');
    }

    // ── Mobile summary screen ──
    syncSummary() {
      var n = this.selected().length;
      if (this.sumBarCount) this.sumBarCount.textContent = n;
      if (this.selCount) this.selCount.textContent = n;
      if (this.deskCount) this.deskCount.textContent = n;
      if (this.summaryBar) this.summaryBar.hidden = n === 0;
      if (this.deskSel) this.deskSel.hidden = n === 0;
      if (n === 0 && this.dialog && this.dialog.classList.contains('is-summary')) this.dialog.classList.remove('is-summary');
      this.renderSummary(); // keeps both the mobile screen and the desktop column in sync
    }
    renderSummary() {
      if (!this.summaryList && !this.deskSelList) return;
      var self = this;
      function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
      var rows = this.selected().map(function (inp) {
        var item = inp.closest('[data-bbx-item]');
        var d = item ? item.dataset : {};
        var cents = parseInt(inp.getAttribute('data-price'), 10) || 0;
        var priceHtml;
        if (self.discount > 0 && cents > 0) {
          var now = cents - Math.round((cents * self.discount) / 100);
          priceHtml = '<s class="bbx__sum-was">' + self.money(cents) + '</s><span class="bbx__sum-now">' + self.money(now) + '</span>';
        } else {
          priceHtml = '<span class="bbx__sum-now">' + self.money(cents) + '</span>';
        }
        var img = d.img ? '<img src="' + esc(d.img) + '" alt="" loading="lazy">' : '';
        // A loupe in both lists, opening the quick view in place. It stays an <a> to the PDP so
        // it still leads somewhere with JS off; the handler preventDefaults it.
        var loupe = d.url
          ? '<a class="bbx__sum-info-link" href="' + esc(d.url) + '" target="_blank" rel="noopener"' +
            ' data-bbx-sum-peek="' + esc(inp.value) + '"' +
            ' aria-label="' + esc(self.infoLabel) + '" title="' + esc(self.infoLabel) + '">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/></svg></a>'
          : '';
        // Počet kusů přímo v seznamu, ať se pro změnu množství nemusí zpátky do detailu.
        // Cena nad ním je za KUS, ne za řádek - tak to čte i košík, takže se ta dvě místa
        // nemohou rozejít.
        var q = self.qtyOf(inp);
        var qty = '<span class="bbx__sum-qty">' +
          '<button type="button" class="bbx__sum-qty-btn" data-bbx-sum-qty="' + esc(inp.value) + '" data-bbx-step="down"' +
          (q <= 1 ? ' disabled' : '') + ' aria-label="' + esc(self.qtyLessLabel) + '">&minus;</button>' +
          '<span class="bbx__sum-qty-val">' + q + '</span>' +
          '<button type="button" class="bbx__sum-qty-btn" data-bbx-sum-qty="' + esc(inp.value) + '" data-bbx-step="up"' +
          (q >= 99 ? ' disabled' : '') + ' aria-label="' + esc(self.qtyMoreLabel) + '">+</button></span>';
        return '<li class="bbx__sum-item">' +
          '<span class="bbx__sum-thumb">' + img + '</span>' +
          '<span class="bbx__sum-info"><span class="bbx__sum-name">' + esc(d.title) + '</span>' +
          '<span class="bbx__sum-price">' + priceHtml + '</span></span>' +
          qty +
          loupe +
          '<button type="button" class="bbx__sum-remove" data-bbx-sum-remove="' + esc(inp.value) + '" aria-label="Remove">×</button></li>';
      });
      var html = rows.join('');
      if (this.summaryList) this.summaryList.innerHTML = html;
      if (this.deskSelList) this.deskSelList.innerHTML = html;
      if (this.summaryEmpty) this.summaryEmpty.hidden = rows.length > 0;
    }

    // ── ATC arm/relabel ──
    syncArmed() {
      this.armed = !!(this.buildRadio && this.buildRadio.checked);
      this.relabelAtc(this.armed ? this.atcText : null);
    }
    relabelAtc(text) {
      var self = this;
      document.querySelectorAll('.add-to-cart-text__content').forEach(function (el) {
        if (self.contains(el)) return;
        // The button that owns this label — flag it so fly-to-cart skips it while it opens the modal.
        var btn = el.closest('button, .product-form__submit, [name="add"]');
        if (text) {
          if (el.getAttribute('data-bbx-orig') === null) el.setAttribute('data-bbx-orig', el.textContent);
          el.textContent = text;
          if (btn) {
            btn.setAttribute('data-fly-skip', ''); // skip my fly-to-cart.js
            btn.classList.add('bbx-atc-pulse'); // emphasis animation while build option is selected
            // Neutralize the theme's delegated add-to-cart: Horizon binds on:click="/handleClick"
            // via a document-CAPTURE listener registered before us, so it (and its fly-to-cart
            // animation) would run before our interceptor. Stripping the attribute stops it; the
            // real add (form submit) is still cancelled by preventDefault in onAtcCapture.
            var oc = btn.getAttribute('on:click');
            if (oc !== null) { btn.setAttribute('data-bbx-onclick', oc); btn.removeAttribute('on:click'); }
          }
        } else if (el.getAttribute('data-bbx-orig') !== null) {
          el.textContent = el.getAttribute('data-bbx-orig');
          el.removeAttribute('data-bbx-orig');
          if (btn) {
            btn.removeAttribute('data-fly-skip');
            btn.classList.remove('bbx-atc-pulse');
            var saved = btn.getAttribute('data-bbx-onclick');
            if (saved !== null) { btn.setAttribute('on:click', saved); btn.removeAttribute('data-bbx-onclick'); }
          }
        }
      });
    }

    open() {
      if (!this.modal) return;
      // Move the modal to <body> so the sticky header / any transformed ancestor can't clip it.
      if (this.modal.parentNode !== document.body) document.body.appendChild(this.modal);
      this.modal.hidden = false;
      void this.modal.offsetWidth;
      this.modal.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      // Open the first category so products are visible without an extra tap.
      if (this.cats.length && !this.cats.some((c) => c.open)) this.cats[0].open = true;
    }
    close() {
      if (!this.modal) return;
      this.modal.classList.remove('is-open');
      document.documentElement.style.removeProperty('overflow');
      var m = this.modal;
      window.setTimeout(function () { m.hidden = true; }, 220);
    }

    money(c) { return bbxFormatMoney(c, this.fmt); }
    selected() { return this.inputs.filter((i) => i.checked); }

    update() {
      var addons = 0;
      var self = this;
      this.selected().forEach((i) => { addons += (parseInt(i.getAttribute('data-price'), 10) || 0) * self.qtyOf(i); });
      var original = this.base + addons;
      var saved = (this.discount > 0 && addons > 0) ? Math.round((addons * this.discount) / 100) : 0;
      var net = original - saved;
      if (this.totalEl) this.totalEl.textContent = this.money(net);
      if (this.compareEl) {
        if (saved > 0) { this.compareEl.textContent = this.money(original); this.compareEl.hidden = false; }
        else { this.compareEl.hidden = true; }
      }
      if (this.saveEl) {
        if (saved > 0) { this.saveEl.textContent = this.saveWord + ' ' + this.money(saved); this.saveEl.hidden = false; }
        else { this.saveEl.hidden = true; }
      }
      this.syncMin();
    }

    // ── Počty kusů ────────────────────────────────────────────────────────────
    // Množství drží samotný checkbox v `data-qty`, ne zvláštní struktura. Selekce je tím pořád
    // jen „které inputy jsou checked" a nemůže se rozejít se stavem někde vedle; při odebrání
    // položky se počet nemusí nikde uklízet.
    qtyOf(input) {
      var n = parseInt(input && input.getAttribute('data-qty'), 10);
      return n > 0 ? Math.min(n, 99) : 1;
    }

    setQty(input, n) {
      if (!input) return;
      var v = Math.max(1, Math.min(99, parseInt(n, 10) || 1));
      input.setAttribute('data-qty', String(v));
      this.update();
      this.syncSummary();
      this.renderSummary();
      if (this.detailItem && this.detailItem.querySelector('.bbx__input') === input) this.syncDetailQty();
    }

    // Počítadlo v detailu píše do TÉHOŽ atributu, takže po přidání do sestavy platí zvolený
    // počet i v souhrnu a v košíku. Když produkt v sestavě ještě není, počet se jen zapamatuje.
    stepDetailQty(step) {
      if (!this.detailItem) return;
      var input = this.detailItem.querySelector('.bbx__input');
      if (!input || input.disabled) return;
      this.setQty(input, this.qtyOf(input) + step);
    }

    syncDetailQty() {
      if (!this.det || !this.det.qty) return;
      var input = this.detailItem ? this.detailItem.querySelector('.bbx__input') : null;
      // Počítadlo se ukazuje jen tam, kde má smysl: uvnitř builderu a u produktu, který jde
      // vybrat. U vyprodaného v režimu konfigurátoru je zbytečné.
      var usable = !!(input && !input.disabled);
      this.det.qty.hidden = !usable;
      if (!usable) return;
      var q = this.qtyOf(input);
      if (this.det.qtyVal) this.det.qtyVal.textContent = String(q);
      if (this.det.qtyDec) this.det.qtyDec.disabled = q <= 1;
      if (this.det.qtyInc) this.det.qtyInc.disabled = q >= 99;
    }

    minMet() { return this.selected().length >= this.minAddons; }

    // Keeps the footer honest: the button is only clickable once the minimum is reached, and the
    // hint counts down instead of leaving the shopper to work out why nothing happens.
    syncMin() {
      var n = this.selected().length;
      var left = this.minAddons - n;
      // `data-bbx-locked` = režim konfigurátoru (nic není skladem). Tlačítko zůstává zašedlé
      // bez ohledu na to, kolik položek je vybráno - jinak by ho splněné minimum zase povolilo.
      if (this.addBtn) this.addBtn.disabled = left > 0 || this.addBtn.hasAttribute('data-bbx-locked');
      if (!this.minHintEl) return;
      if (this.minAddons <= 0 || left <= 0) { this.minHintEl.hidden = true; return; }
      var tpl = n === 0 ? this.minHintText : this.minLeftText;
      var count = n === 0 ? this.minAddons : left;
      this.minHintEl.textContent = (tpl || '').replace('{{ count }}', count);
      this.minHintEl.classList.toggle('is-close', left === 1);
      this.minHintEl.hidden = !tpl;
    }

    addToCart() {
      if (this.busy || !this.minMet()) return;
      // Pojistka pro případ, že by se ke kliku někdo dostal jinak než tlačítkem (klávesnice,
      // rozšíření, cizí skript). Zamčený builder nesmí nic odeslat.
      if (this.addBtn && this.addBtn.hasAttribute('data-bbx-locked')) return;
      this.busy = true;
      if (this.addBtn) this.addBtn.classList.add('is-loading');
      var root = (window.Shopify && window.Shopify.routes) ? window.Shopify.routes.root : '/';
      var items = [{ id: this.mainVariant, quantity: 1 }];
      this.selected().forEach((i) => items.push({ id: Number(i.value), quantity: this.qtyOf(i) }));
      var self = this;
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .then((r) => { if (!r.ok) throw new Error('add ' + r.status); return r.json(); })
        .then(() => fetch(root + 'cart.js').then((r) => r.json()))
        .then((cart) => {
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { resource: null, sourceId: 'bundle-builder', data: { source: 'bundle-builder', itemCount: cart.item_count } },
          }));
          var drawer = document.querySelector('cart-drawer-component');
          if (drawer && typeof drawer.open === 'function' && drawer.hasAttribute('auto-open')) drawer.open();
          self.reset();
        })
        .catch((err) => { console.error('[bundle-builder]', err); })
        .then(() => { self.busy = false; if (self.addBtn) self.addBtn.classList.remove('is-loading'); });
    }

    reset() {
      this.inputs.forEach((i) => { i.checked = false; i.removeAttribute('data-qty'); });
      this.update();
      this.closePreview();
      if (this.dialog) this.dialog.classList.remove('is-summary');
      this.syncSummary();
      this.close();
    }
  });
}
